export function getResourceName(urlString: string): string {
    let name = '';
    try {
        let url = new URL(urlString);
        let paths = url.pathname.split('/');
        name = paths[paths.length - 1];
    } catch (error) {
        name = urlString;
    }

    return name;
}
